import { render, staticRenderFns } from "./PublicationCitesTab.vue?vue&type=template&id=fca4cb18&scoped=true"
import script from "./PublicationCitesTab.vue?vue&type=script&lang=js"
export * from "./PublicationCitesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca4cb18",
  null
  
)

export default component.exports